import type { Schema, Node } from '@atlaskit/editor-prosemirror/model';
import type { Content, Root } from 'mdast';

import type { Handlers } from './state';
import { State } from './state';

interface ToProseMirrorOptions {
	sourceMarkdown?: string;
}

/**
 * Creates a function that converts an mdast node to a ProseMirror document.
 * Accepts both `Root` nodes (from fromMarkdown) and individual `Content` nodes.
 *
 * @param schema - The ProseMirror schema to use for node creation
 * @param handlers - Handlers mapping mdast node types to PM conversion functions
 */
export function toProseMirror(schema: Schema, handlers: Handlers) {
	return function (mdast: Root | Content, options?: ToProseMirrorOptions): Node | null {
		const state = new State(schema, handlers, options?.sourceMarkdown);
		// Root is not in the Content union in @types/mdast v3 but is a valid entry point.
		state.parseTokens([mdast as Content]);
		return state.closeNode();
	};
}
